import { render, staticRenderFns } from "./ToznyLoader.vue?vue&type=template&id=16047552&"
import script from "./ToznyLoader.vue?vue&type=script&lang=js&"
export * from "./ToznyLoader.vue?vue&type=script&lang=js&"
import style0 from "./ToznyLoader.vue?vue&type=style&index=0&id=16047552&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports